import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/@mui/utils/clamp/index.js';

var require$$2 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$2 as default };
